import { Rocket } from "lucide-react";
import { Link } from "react-router-dom";
import logoImage from "@/assets/logo.png";

interface LogoProps {
  showText?: boolean;
  size?: "sm" | "md" | "lg";
  linkTo?: string;
}

export function Logo({ showText = true, size = "md", linkTo = "/" }: LogoProps) {
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  const textSizes = {
    sm: "text-sm",
    md: "text-xl",
    lg: "text-2xl",
  };

  const content = (
    <div className="flex items-center gap-2 group">
      <div className="relative">
        <img 
          src={logoImage} 
          alt="TheMoonRun Logo" 
          className={`${sizeClasses[size]} rounded-lg transition-transform group-hover:scale-110`}
        />
        <div className="absolute inset-0 blur-lg bg-primary/30 animate-pulse-glow -z-10" />
      </div>
      {showText && (
        <span className={`font-display font-bold tracking-wider hidden sm:block ${textSizes[size]}`}>
          <span className="text-foreground">THE</span>
          <span className="gradient-text">MOON</span>
          <span className="text-foreground">RUN</span>
        </span>
      )}
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo}>{content}</Link>;
  }

  return content;
}
